import { render, staticRenderFns } from "./supproject.vue?vue&type=template&id=5cd5266e&scoped=true&"
import script from "./supproject.vue?vue&type=script&lang=js&"
export * from "./supproject.vue?vue&type=script&lang=js&"
import style0 from "./supproject.vue?vue&type=style&index=0&id=5cd5266e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd5266e",
  null
  
)

export default component.exports